import { useState } from "react";

import { Checkbox } from "~/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "~/components/ui/dialog";

interface TermsCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
}

export function TermsCheckbox({
  checked,
  onCheckedChange,
  id = "terms-checkbox",
}: TermsCheckboxProps) {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <>
      <div className="flex items-start gap-2">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={(val) => onCheckedChange(val === true)}
          className="mt-0.5"
        />
        <label htmlFor={id} className="text-sm leading-snug text-neutral-700">
          Acepto los{" "}
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setTermsOpen(true);
            }}
            className="font-semibold underline hover:text-primary-600"
          >
            Términos y Condiciones
          </button>{" "}
          y la{" "}
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setPrivacyOpen(true);
            }}
            className="font-semibold underline hover:text-primary-600"
          >
            Política de Privacidad
          </button>
        </label>
      </div>

      <Dialog open={termsOpen} onOpenChange={setTermsOpen}>
        <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>Términos y Condiciones</DialogTitle>
          </DialogHeader>
          <div className="prose prose-sm text-neutral-600">
            <p>
              Estos son los términos y condiciones de uso de la plataforma. Al registrarte y
              utilizar nuestros servicios, aceptas cumplir con las siguientes condiciones.
            </p>
            <p>
              Este contenido se actualizará próximamente con los términos y condiciones completos.
            </p>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={privacyOpen} onOpenChange={setPrivacyOpen}>
        <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>Política de Privacidad</DialogTitle>
          </DialogHeader>
          <div className="prose prose-sm text-neutral-600">
            <p>
              Tu privacidad es importante para nosotros. Esta política describe cómo recopilamos,
              usamos y protegemos tu información personal.
            </p>
            <p>
              Este contenido se actualizará próximamente con la política de privacidad completa.
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
